export default __webpack_public_path__ + "static/media/plan-bg.113a04e5.svg";